import { withTranslations } from '@/utils/Language';
import suggestEditsEn from '@/assets/i18n/suggestEdits/en.json';
import shareResourceDropdownEn from '@/assets/i18n/shareResourceDropdown/en.json';
import printButtonEn from '@/assets/i18n/printButton/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...suggestEditsEn, ...shareResourceDropdownEn, ...printButtonEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/suggestEdits/${lang}.json`),
      import(`@/assets/i18n/shareResourceDropdown/${lang}.json`),
      import(`@/assets/i18n/printButton/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([suggestEdits, shareResourceDropdown, printButton, ui, languages, languagesTranslated]) => ({
      ...suggestEdits.default,
      ...shareResourceDropdown.default,
      ...printButton.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
